import { httpRequest } from "@services/http";
import { AdTemplateSerializer } from "../../../shared/models/serializers/adTemplateSerializer";
import { AdTemplate } from "@models/AdTemplate.model";

export class CommandListLayers {
  async run(templateId: number) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/content/ad_templates/${templateId}/`;
    try {
      const response = await httpRequest(url, {
        method: "GET",
        body: {},
      }).catch((err) => console.log(err));
      return this.deserialize(response);
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }

  deserialize(data: any): AdTemplate {
    const serializer = new AdTemplateSerializer();
    return serializer.deserialize(data);
  }
}
